<template>
  <div class="mainPage">
    <div class="header_banner">
      <div class="infoCon">
        <div class="centerBg">
          <!-- <img src="../img/harmonious2025/banner.png" alt="" class="left" /> -->
        </div>
      </div>
    </div>
    <div class="content">
      <div class="rightBox">
        <!-- <div class="back_arrow" @click="goBack()"><</div> -->
        <div class="video_wrap">
          <div class="video_corner_block" @click="goBack">
            <div class="hamburger-button">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p>节目单</p>
          </div>
          <div
            class="cover_con"
            v-if="!showVideo && videoInfo && videoInfo.cover_url"
            @click="showVideo = true"
          >
            <img
              src="../img/chineseCultureVideoExhibition2025/play.png"
              alt=""
              class="play_icon"
            />
            <img :src="videoInfo.cover_url" alt="" class="video_cover" />
          </div>
          <div class="videoContainer" v-if="showVideo">
            <video
              :src="videoInfo.video_url"
              id="liveVideo"
              autoplay
              controls
              controlsList="nodownload"
            ></video>
          </div>
          <ul class="video_list" v-if="subjectDetail.type == 1">
            <li
              v-for="(v, i) in videoList"
              :key="i"
              @click="playVideo(i)"
              :class="{ active: selectedVideoIndex === i }"
            >
              {{ i + 1 }}
            </li>
            <!-- <div class="link" @click="goProgramLink()">
              <img
                src="../img/chineseCultureVideoExhibition2025/link.png"
                alt=""
                class="link_icon"
              />
              <div class="name_con">
                <p class="cn">节目链接</p>
                <p class="en">Program link</p>
              </div>
            </div> -->
          </ul>
          <div class="link_con" v-if="subjectDetail.type == 2">
            <div
              class="link"
              @click="goProgramLink()"
              v-if="subjectDetail.internal_address"
            >
              <img
                src="../img/chineseCultureVideoExhibition2025/link.png"
                alt=""
                class="link_icon"
              />
              <div class="name_con">
                <p class="cn">节目链接</p>
                <p class="en">Program link</p>
              </div>
            </div>
            <div
              class="link"
              @click="goOverseasLink()"
              v-if="subjectDetail.external_address"
            >
              <img
                src="../img/chineseCultureVideoExhibition2025/link.png"
                alt=""
                class="link_icon"
              />
              <div class="name_con">
                <p class="cn">外网链接</p>
                <p class="en">Overseas Links</p>
              </div>
            </div>
          </div>
        </div>
        <div class="projectProfile detail">
          <div class="box">
            <div class="name_cn">
              {{ subjectDetail.name }}
              <span class="lang">{{ languageBracket }}</span>
            </div>
            <div class="name_en">{{ subjectDetail.name_en }}</div>
            <div class="text">
              {{ subjectDetail.describe }}
            </div>
            <div class="text2">
              {{ subjectDetail.describe_en }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <img src="../img/harmonious2025/footer.png" />
      <!-- <div class="copyright">版权所有 © 中央广播电视总台 中文联盟</div> -->
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video
              :src="currentVideoUrl"
              id="liveVideo"
              autoplay
              controls
              controlsList="nodownload"
            ></video>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Qs from "qs";
import language from "./common/language";
import frame0 from "../img/harmonious2025/Frame.png";
import frame1 from "../img/harmonious2025/Frame(1).png";
import frame2 from "../img/harmonious2025/Frame(2).png";
import frame3 from "../img/harmonious2025/Frame(3).png";
import frame4 from "../img/harmonious2025/Frame(4).png";
import frame5 from "../img/harmonious2025/Frame(5).png";
import frame6 from "../img/harmonious2025/Frame(6).png";
export default {
  name: "chinesebridge",
  components: {
    language,
  },
  metaInfo() {
    return {
      title: "2025和合之美，中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2025和合之美，中央广播电视总台精品节目展播",
        },
        {
          name: "description",
          content: "2025和合之美，中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: function() {
    return {
      languageList: [
        {
          type: "中文",
          alias: "yangshi2025-cn",
          url: frame0,
          color: "#FA877D",
          look: "VIEW DETAIL",
        },
        {
          type: "English",
          alias: "yangshi2025-en",
          url: frame1,
          color: "#778EDA",
          look: "VIEW DETAIL",
        },
        {
          type: "Русский",
          alias: "yangshi2025-ru",
          url: frame2,
          color: "#AE79B2",
          look: "ПОСМОТРЕТЬ ДЕТАЛИ",
        },
        {
          type: "Казахский",
          alias: "yangshi2025-ka",
          url: frame3,
          color: "#3BB3BE",
          look: "МӘЛІМЕТТЕРДІ ҚАРАУ",
        },
        {
          type: "Español",
          alias: "yangshi2025-sp",
          url: frame4,
          color: "#B79436",
          look: "VER DETALLE",
        },
        {
          type: "Português Brasileiro",
          alias: "yangshi2025-bp",
          url: frame5,
          color: "#86B364",
          look: "VEJA DETALHES",
        },
        {
          type: "Français",
          alias: "yangshi2025-fr",
          url: frame6,
          color: "#4EA3EE",
          look: "Voir les détails",
        },
      ],
      isChrome: true,
      isLogin: false,
      isPlay: false,
      currentVideoUrl: "",
      imgUrl: "",
      user: {
        username: "",
        email: "",
      },
      lang: "cn",
      isShowGuide: true,
      subject_info: [],
      courseList: {},
      activeTab: 0,
      subject_id: null,
      subject_name: [],
      subject_subText: [],
      showDetail: false,
      videoList: [],
      showVideo: false,
      collection_id: "",
      videoIndex: "",
      routeLang: "",
      selectedVideoIndex: 0,
      subjectDetail: "",
      videoInfo: {
        cover_url: "",
      },
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    languageBracket() {
      const readable = this.getReadableLangFromRoute(this.routeLang);
      return readable ? `【${readable}】` : "";
    },
  },
  created() {
    this.collection_id = this.$route.query.collection_id;
    this.videoIndex = this.$route.query.videoIndex;
    this.routeLang = this.$route.query.lang;

    this.getCollectList();
    this.getSubjectInfo();
    this.getVideoList();
  },
  mounted() {
    this.customCheckLogin();
    this.checkChrome();

    let activeTab = this.$route.query.tab;
    if (activeTab) {
      this.activeTab = activeTab;
    }
  },
  methods: {
    /**
     * 从路由 lang 推断在 languageList 中对应的 type（人类可读）
     */
    getReadableLangFromRoute(lang) {
      if (!lang) return "";
      const list = this.languageList || [];
      // 1) 直接与 type 匹配
      const byType = list.find((it) => it.type === lang);
      if (byType) return byType.type;
      // 2) 直接与 alias 匹配
      const byAlias = list.find((it) => it.alias === lang);
      if (byAlias) return byAlias.type;
      // 3) 短码到 alias 的映射
      const shortToAlias = {
        cn: "yangshi2025-cn",
        zh: "yangshi2025-cn",
        en: "yangshi2025-en",
        ru: "yangshi2025-ru",
        ka: "yangshi2025-ka",
        sp: "yangshi2025-sp",
        es: "yangshi2025-sp",
        bp: "yangshi2025-bp",
        pt: "yangshi2025-bp",
        fr: "yangshi2025-fr",
      };
      const mappedAlias = shortToAlias[lang];
      if (mappedAlias) {
        const byMapped = list.find((it) => it.alias === mappedAlias);
        if (byMapped) return byMapped.type;
      }
      // 4) 找不到就返回原值
      return lang;
    },
    // 登录
    toLogin() {
      window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    // 注册
    toRegister() {
      window.location.href =
        "https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=" +
        encodeURIComponent(window.location.href);
    },
    // 检查是否登录 获取用户信息
    customCheckLogin() {
      this.checkLogin()
        .then((res) => {
          if (res.data.success) {
            this.isLogin = true;
            this.user = res.data.data;
          } else {
            this.isLogin = false;
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },
    // 退出登录
    toLogOut() {
      this.$utils.get("/user/api/logout").then((res) => {
        if (res.data.success) {
          this.isLogin = false;
        }
      });
    },
    goBack() {
      this.$router.push({
        path: "/pcpage/hm2025",
      });
    },
    goProgramLink() {
      window.open(this.subjectDetail.internal_address);
    },
    goOverseasLink() {
      window.open(this.subjectDetail.external_address);
    },
    getCollectList() {
      this.$utils
        .get("/subject/lesson_Collection/getlist", {
          limit: 999,
          alias: "2025mlzw",
        })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = res.data.data.list;
            // console.log(this.collection_id,this.active)
          }
        });
    },
    getVideoList() {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: this.collection_id,
          order: "sort",
          limit: 30,
        })
        .then((res) => {
          if (res.data.success) {
            this.videoList = res.data.data.list;
            const initialIndex = this.videoIndex ? Number(this.videoIndex) : 0;
            this.selectedVideoIndex = isNaN(initialIndex) ? 0 : initialIndex;
            this.videoInfo = this.videoList[this.selectedVideoIndex];
          }
        });
    },
    getSubjectInfo() {
      this.$utils
        .get("/subject/lesson_Collection/read", {
          id: this.collection_id,
        })
        .then((res) => {
          if (res.data.success) {
            this.subjectDetail = res.data.data;
          }
        });
    },
    playVideo(index) {
      this.showVideo = false;
      this.selectedVideoIndex = index;
      this.videoInfo = this.videoList[index];
    },

    //排序
    compare(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function() {
        //
        $("#liveVideo").bind("contextmenu", function() {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
    checkChrome() {
      var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
      if (!isChrome) {
        this.isChrome = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  user-select: none;

  &::before {
    content: "";
    position: absolute;
    top: 570px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f6fdff;
    z-index: -2;
  }

  .agentTip {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #ffe6a1;
    text-align: center;
    position: absolute;
    z-index: 5;
    color: #c40000;
  }

  .agentTip .closeTip {
    position: absolute;
    right: 24px;
    top: 0px;
    font-size: 30px;
    color: #282828;
    cursor: pointer;
  }

  .header_banner {
    position: relative;
    z-index: -1;
    background-image: url(../img/harmonious2025/banner.png);
    height: 600px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    header {
      position: absolute;
      height: 50px;
      line-height: 50px;
      z-index: 2;
      // border-bottom: 1px solid rgba(#fff, 0.3);
      top: 0;
      width: 100%;
      margin: auto;
      color: #fff;

      .center {
        color: #8590cc;
        width: 1200px;
        margin: auto;

        a {
          color: #8590cc;
          margin-right: 15px;
          // opacity: 0.8;
        }
      }

      .left {
        float: left;
      }

      .right {
        line-height: 50px;
        float: right;
        margin-right: -55px;

        img {
          vertical-align: text-top;
          margin-right: 15px;
        }

        .loginCon {
          display: inline-block;
          margin-left: 30px;

          span {
            cursor: pointer;
          }

          .username {
            margin-right: 12px;
          }
        }
      }
    }

    .infoCon {
      .centerBg {
        width: 1200px;
        margin: auto;
        position: absolute;
        top: 20px;
        left: 90px;
        right: 0;

        .left {
          float: left;
          margin-top: 20px;
        }

        .right {
          float: right;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 1200px;
    // height: 2860px;
    margin: auto;
    margin-top: -30px;

    .rightBox {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin: auto;
      margin-bottom: 200px;
      margin-top: -100px;

      .projectProfile {
        position: relative;
        background: #ffffff;
        border: 2px solid #e0e0e0;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 30px;
        width: 100%;
        max-width: 1200px;
        &.detail {
          .box {
            .text {
              margin-top: 10px;
              padding-left: 20px;
              padding-right: 20px;
            }
            .text2 {
              padding-left: 20px;
              padding-right: 20px;
            }
          }
        }
        .kuang1 {
          position: absolute;
          margin-top: 10px;
          z-index: 100;
        }
        .icon3 {
          position: absolute;
          top: 0;
        }
        .icon4 {
          position: absolute;
          bottom: 15px;
          right: 45px;
        }

        .box {
          width: 95%;
          // height: 250px;
          z-index: 10;
          margin: auto;
          margin-top: 10px;
          margin-bottom: 40px;
          .name_cn {
            font-size: 30px;
            font-weight: bold;
            color: #282828;
            margin-bottom: 10px;
            padding-left: 20px;
            padding-top: 20px;

            span:first-child {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-size: 24px;
              color: #38475d;
              font-weight: normal;
              margin-left: 8px;
            }

            span:last-child {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-size: 24px;
              color: #38475d;
              font-weight: normal;
              margin-left: 8px;
            }
          }
          .name_en {
            font-size: 18px;
            font-weight: bold;
            color: #93a4aa;
            padding-left: 20px;
          }

          .text {
            font-size: 16px;
            color: #282828;
            padding-top: 18px;
            padding-left: 35px;
            padding-right: 55px;
            margin-top: 25px;
            line-height: 26px;
            text-align: justify;
            text-indent: 2em;
          }

          .text2 {
            font-size: 15px;
            color: #282828;
            padding-left: 35px;
            padding-right: 55px;
            line-height: 24px;
            padding-bottom: 10px;
            text-align: justify;
            // text-indent:2em;
          }
        }
      }
      .back_arrow {
        font-size: 40px;
        color: #fff;
        cursor: pointer;
        margin-bottom: 20px;
      }
      .video_wrap {
        position: relative;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;

        .video_corner_block {
          position: absolute;
          top: 0px;
          left: -60px;
          width: 60px;
          height: 80px;
          background: #38475d;
          border-radius: 10px 0px 0px 10px;
          z-index: 10;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 10px 0;
          cursor: pointer;
          transition: background-color 0.3s ease;

          &:hover {
            background: #4a5a6b;
          }

          .hamburger-button {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 36px;
            height: 40px;
            cursor: pointer;
            margin-bottom: 8px;

            span {
              display: block;
              height: 3px;
              width: 100%;
              background-color: #fff;
              // border-radius: 1px;
              // transition: all 0.3s ease;
            }
          }

          p {
            font-family: Inter, Inter;
            color: #fff;
            font-size: 12px;
            font-weight: 400;
            margin: 0;
            text-align: center;
            line-height: 1.2;
          }
        }

        .cover_con {
          position: relative;
          cursor: pointer;
          .play_icon {
            position: absolute;
            left: 15px;
            bottom: 15px;
            width: 60px;
          }
          .video_cover {
            display: block;
            width: 100%;
            height: 619px;
            border: solid 2px #e0ac68;
            margin-bottom: 25px;
            object-fit: cover;
          }
        }
        .videoContainer {
          position: relative;
          width: 100%;
          height: 619px;
          margin-bottom: 25px;
          video {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .video_list {
          margin-bottom: 30px;
          overflow: hidden;
          li {
            width: 71px;
            height: 71px;
            float: left;
            margin-right: 15px;
            border-radius: 10px;
            background-color: #fad77d;
            border: 1px solid #b79436;
            font-size: 40px;
            color: #a1896b;
            font-weight: bold;
            line-height: 70px;
            text-align: center;
            cursor: pointer;
            margin-bottom: 10px;
            &.active {
              background-color: #b79436;
              color: #fff;
              border-color: #a8822e;
            }
          }
          .link {
            height: 73px;
            float: left;
            padding: 0 26px;
            box-sizing: border-box;
            border-radius: 10px;
            background-color: #fad77d;
            border: 1px solid rgba(186, 159, 125, 1);
            display: flex;
            align-items: center;
            cursor: pointer;
            .link_icon {
              margin-right: 15px;
            }
            .name_con {
              color: #a1896b;
              font-weight: bold;
              .cn {
                font-size: 18px;
              }
              .en {
                font-size: 16px;
              }
            }
          }
        }
        .link_con {
          display: flex;
          align-items: center;
          justify-content: center;
          .link {
            height: 73px;
            float: left;
            padding: 0 26px;
            box-sizing: border-box;
            border-radius: 10px;
            background-color: #fad77d;
            border: 1px solid rgba(186, 159, 125, 1);
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-bottom: 30px;
            &:nth-child(1) {
              margin-right: 23px;
            }
            .link_icon {
              margin-right: 15px;
            }
            .name_con {
              color: #a1896b;
              font-weight: bold;
              .cn {
                font-size: 18px;
              }
              .en {
                font-size: 16px;
              }
            }
          }
        }
      }

      .classBox {
        .series_info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .info_left {
            .cloud_con {
              width: 136px;
              height: 100px;
              background: url(../img/chineseCultureVideoExhibition2025/cloud.png)
                no-repeat center;
              background-position-y: bottom;
              position: relative;
              float: left;

              .serise_icon_con {
                position: absolute;
                left: 25px;
                top: 15px;
                border: solid 3px #ffffff;
                img {
                  border-radius: 6px;
                  width: 60px;
                  height: 60px;
                  display: block;
                }
              }
            }
            .name_con {
              float: left;
              margin-top: 25px;
              margin-left: -30px;
              .cn {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 30px;
                color: #364347;
                margin-bottom: 4px;
              }
              .en {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 16px;
                color: #93a4aa;
              }
            }
          }
          .look_detail_icon {
            cursor: pointer;
            width: 208px;
            height: 30px;
          }
        }

        .text_cn {
          font-size: 16px;
          color: #5e696d;
          line-height: 24px;
          margin-top: 20px;
          margin-bottom: 5px;
        }

        .text_en {
          font-size: 14px;
          color: #5e696d;
          line-height: 20px;
          // margin-bottom: 20px;
        }

        .swiper_con {
          margin-top: 25px;
          margin-left: 0rem;
          margin-bottom: 40px;
          position: relative;

          .swiper-container {
            position: unset;
          }

          .swiper {
            .swiper-slide {
              width: 3.6rem !important;

              .swiperBox {
                overflow: hidden;
              }
            }

            .video_con {
              width: 3.6rem;

              .huan_icon {
                display: block;
                // position: absolute;
                width: 0.78rem;
                bottom: 0;
                margin-top: -2rem;
                margin: auto;
                margin-top: -2rem;
                position: relative;
                z-index: 3;
              }

              .video_name_con {
                width: 4.8rem;
                height: 1.1rem;
                line-height: 1.2rem;
                font-weight: bold;
                background-color: #04c7de;
                border-radius: 0.2rem;
                border: solid 0.04rem #000000;
                font-family: HYJiJinTiW;
                text-align: center;
                font-size: 0.3rem;
                color: #ffffff;
                margin: auto;
                position: relative;
                z-index: 2;
                margin-top: -0.4rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                padding: 0 0.2rem;
                box-sizing: border-box;
              }

              .video_cover {
                width: 3.6rem;
                height: calc(3.4rem / (16 / 9));
                background-color: #f6453f;
                // border-radius: .2rem;
                // border: solid .04rem #000000;
                // overflow: hidden;
                // margin-top: -.4rem;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                }
              }

              .titleBox {
                position: absolute;
                height: 55px;
                margin-top: -55px;
                width: 100%;
                color: #fff;
                background-color: #55565775;
                text-align: left;
                z-index: 100;
                display: flex;
                align-items: center;

                .course_title {
                  padding: 10px 20px;

                  .cn {
                    font-size: 16px;
                  }

                  .en {
                    margin-top: 4px;
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .swiper-button-prev {
            background-image: url(../img/chineseCultureVideoExhibition2025/prev.png);
            position: absolute;
            left: -75px;
            top: 90px;
          }

          .swiper-button-next {
            background-image: url(../img/chineseCultureVideoExhibition2025/next.png);
            right: -75px;
            top: 90px;
          }
        }

        .series_type2_con {
          overflow: hidden;
          margin-top: 15px;
          .cover {
            width: 352px;
            height: 220px;
            display: block;
            float: left;
            margin-right: 22px;
          }
          .des_con {
            font-size: 14px;
            color: #5e696d;
            line-height: 24px;
            float: left;
            width: calc(100% - 22px - 352px);
            .cn {
              margin-bottom: 13px;
              display: -webkit-box; /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical; /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 4; /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden; /* 隐藏超出的内容 */
            }
            .en {
              line-height: 20px;
              display: -webkit-box; /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical; /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 5; /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden; /* 隐藏超出的内容 */
            }
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    width: 100%;

    .copyright {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 12px;
      color: #38475d;
      text-align: center;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }
  }

  #videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }

  #videoPlayWrapper .closeVideo {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
  }

  .videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .videoContainer {
    text-align: center;
    width: 100%;
  }

  .videoContainer video {
    width: 62%;
  }

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
}

// 110%
@media screen and (max-width: 1750px) {
  .mainPage .header_banner {
    height: 560px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4rem !important;

        .video_con {
          width: 4rem;

          .video_cover {
            width: 4rem;
            height: calc(4rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -360px;
    .copy {
      bottom: 100px;
    }
  }
}

// 125%
@media screen and (max-width: 1540px) {
  .mainPage .header_banner {
    height: 540px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4.5rem !important;

        .video_con {
          width: 4.5rem;

          .video_cover {
            width: 4.5rem;
            height: calc(4.3rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -400px;
  }
}

// 150%
@media screen and (max-width: 1280px) {
  .mainPage .header_banner {
    height: 410px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 5rem !important;

        .video_con {
          width: 5rem;

          .video_cover {
            width: 5rem;
            height: calc(4.7rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .header_banner .infoCon .centerBg {
    transform: scale(0.7);
    top: -20px;
    left: 130px;
  }

  .projectProfile {
    transform: scale(0.9);
    margin-left: -100px;
  }

  .mainPage .content {
    .rightBox {
      transform: scale(0.9);
      margin-top: -140px;
      margin-left: 70px;
    }

    // height: 3000px;
    // transform: scale(0.8);
  }
}
</style>
